import { computed, inject, type Ref } from 'vue'

export type GetConditionValueInject = (id: string, parentIndex?: number, parentId?: string) => boolean

export default function useConditions(
    id: Ref<string>,
    parentIndex?: Ref<number | undefined>,
    parentId?: Ref<string | undefined>,
) {
    const getDisplayValue = inject<GetConditionValueInject>('getDisplayValue', () => true)
    const getDisableValue = inject<GetConditionValueInject>('getDisableValue', () => false)

    const isDisplayed = computed(() => getDisplayValue(id.value, parentIndex?.value, parentId?.value))

    const isDisabled = computed(() => {
        return getDisableValue(id.value, parentIndex?.value, parentId?.value)
    })

    return {
        isDisplayed,
        isDisabled,
    }
}
